<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style lang="scss" scoped>
@import "styles/index";

</style>
<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #7732FC !important;
}
.el-pagination .btn-next,
.el-pagination .btn-prev,
.el-pager li {
  &:hover {
    color: #7732FC !important;
  }
}
.search-panel{
  width:100%;
  min-height:92px;
  height:92px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 0 24px;
  box-sizing: border-box;
  margin-bottom:24px;
  // .el-input__inner{
  //   height:30px;
  //   min-height:30px;
  // }
}
.check-btn{
  padding:0 20px;
  min-height:40px;
  color:#fff;
  font-size:14px;
  background: #7732FC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  border:0;
}
.reset-btn{
  padding:0 20px;
  min-height:40px;
  color:#7732FC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-color:#7732FC;
  border:1px solid #7732fc;
  cursor: pointer;
  background: rgba(0,0,0,0);
}
.common-bottom-panel{
  width:100%;
  background: #fff;
  height:calc(100vh - 112px - 106px - 64px);
  display: flex;
  flex-direction: column;
  overflow-y:auto;
  border-radius: 8px;
  padding: 32px 20px;
  box-sizing: border-box;
}

</style>
